import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteActivitySchedulesService = async (
  activityScheduleId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/activities/schedules/${activityScheduleId}`);
};

export default deleteActivitySchedulesService;
